<!-- //Main Header -->



    <header class="index_header reference_holder" style="position: relative">
      <nav class="new_navigation">
        <div class="the_logo" style="display: flex; align-items: center">
          <img
            src="../../../assets/images/shell-4-logo-png-transparent.png"
            alt=""
            style="width: 40px; height: 40px; object-fit: contain; margin-right: 0.5rem"
            class="logo"
          />
          <p style="margin-bottom: 0; font-size: 1.6rem; color: rgb(255, 255, 255)">
            Shell Petroleum Development Company
          </p>
        </div>
        <!-- <div class="first_menu">
          <button class="link">Home</button>
          <button class="link">About</button>
          <button class="link">Features</button>
        </div> -->

        <div class="second_menu">
          <button class="link" [routerLink]="['/auth/login']">Sign in</button>
          <!-- <button class="link">Subscribe</button> -->
        </div>
      </nav>
      <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
        <ol class="carousel-indicators">
          <li data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active"></li>
          <li data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1"></li>
          <li data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2"></li>
        </ol>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="alter_display">
              <div class="carousel-caption d-none d-md-block">
                <h5>Lands Management</h5>
                <p>All Land titles and land related operations</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="alter_display">
              <div class="carousel-caption d-none d-md-block">
                <h5>Pipelines Management</h5>
                <p>All Pipelines, Licences and related operations</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="alter_display">
              <div class="carousel-caption d-none d-md-block">
                <h5>Incidence Management</h5>
                <p>Incidence information and all related operations.</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="alter_display">
              <div class="carousel-caption d-none d-md-block">
                <h5>Correspondence Management</h5>
                <p>Correspondence information and all related operations.</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="alter_display">
              <div class="carousel-caption d-none d-md-block">
                <h5>Medical Records Management</h5>
                <p>Medical information and all related operations.</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="alter_display">
              <div class="carousel-caption d-none d-md-block">
                <h5>GMOU Management</h5>
                <p>GMOU information and all related operations.</p>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="alter_display">
              <div class="carousel-caption d-none d-md-block">
                <h5>Scholarship Management</h5>
                <p>Scholarship information and all related operations.</p>
              </div>
            </div>
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleCaptions" role="button" data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </a>
      </div>

      <img
        src="../../../assets/images/epims.png"
        alt=""
        class="footer_sticker"
        style="position: fixed; bottom: 10px; right: 10px; height: 5%"
      />
    </header>

    <script>
      function changeBg() {
        const images = [
          ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(/img/random/1.webp)',
          ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(/img/random/2.jpg)',
          ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(/img/random/3.jpg)',
          ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(/img/random/4.jpg)',
          ' linear-gradient(to right, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),url(/img/random/5.jpg)',
          ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(/img/random/6.jpg)',
          ' linear-gradient(to right, rgba(0, 0, 0, 0.596), rgba(0, 0, 0, 0.596)),url(/img/random/7.jpg)',
        ];

        const theChange = document.querySelector('.reference_holder');
        const change = images[Math.floor(Math.random() * images.length)];
        theChange.style.backgroundImage = change;
        theChange.style.transition = 'all 2000';
      }

      setInterval(changeBg, 5000);
    </script>

    <!-- <script src="sass/vendors/epims.js"></script> -->
    <script
      src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta1/dist/js/bootstrap.bundle.min.js"
      integrity="sha384-ygbV9kiqUc6oa4msXn9868pTtWMgiQaeYH7/t7LECLbyPA2x65Kgf80OJFdroafW"
      crossorigin="anonymous"
    ></script>





<!-- <header class="nav_header container-fluid">
   
  <nav class="navigations">
      <div class="navigation_logo">EPIMS</div>
     
      <div class="nav_list">
          <ul class="nav_links">
            
              <li class="nav_link">Home</li>  
              <li class="nav_link">About</li>  
              <li class="nav_link">Partners</li>  
              <li class="nav_link">Link</li>  
              <li class="nav_link">Link</li>  

              <span class="links">
                  
             
                    <li [routerLink]="['/auth/login','signup']" class="nav_link">Signup</li>  
            
                  
                    <li [routerLink]="['/auth/login','login']" class="nav_link">Login</li>  
                  
                 
                  
                 
              </span>
          </ul>
      </div>

  </nav>


  <div class="captions">
      <h3 class="main_caption">
          <span>Boost production</span>
          <span>and enhance your operations</span>
      </h3>
      <p class="secondary_caption">But I must explain to you how all this mistaken idea of denouncing</p>
  </div>

  <div class="the__action_btn">
      <button class="the_first-btn">Register</button>
      <button class="the_second-btn">Request Demo</button>
  </div>
  <div class="epims_hero_img"></div>

  <img src="assets/images/left.svg" alt="" class="small_balls right">
  <img src="assets/images/right.svg" alt="" class="small_balls left">


 
</header>


<main class="index_main container-fluid">
  <section class="feature_cards">
      <div class="cards">
          <img src="assets/images/right.svg" alt="">
          <h4 class="heading">Project Management</h4>
          <p class="sub">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veritatis obcaecati ducimus
              laborum
              reiciendis nostrum ipsam!</p>
      </div>
      <div class="cards">
          <img src="assets/images/right.svg" alt="">
          <h4 class="heading">Project Management</h4>
          <p class="sub">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veritatis obcaecati ducimus
              laborum
              reiciendis nostrum ipsam!</p>
      </div>
      <div class="cards">
          <img src="assets/images/right.svg" alt="">
          <h4 class="heading">Project Management</h4>
          <p class="sub">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veritatis obcaecati ducimus
              laborum
              reiciendis nostrum ipsam!</p>
      </div>
  </section>

  <section class="briefing">
      <div class="case row">
          <div class="main__briefing col-md-5 col-sm-12">
              <h3 class="the_title">Payroll Management</h3>

              <p class="sub">Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio vero officia vel animi
                  incidunt consequuntur!</p>

              <ul>
                  <li>  Lorem ipsum dolor sit, amet consectetur adipisicing elit. At reiciendis sed quo, facilis
                      quas nulla deleniti!</li>  
                  <li>  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Delectus repellat ut cumque
                      perspiciatis mollitia, nihil sed?</li>  
                  <li>  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Delectus repellat ut cumque
                      perspiciatis mollitia, nihil sed?</li>  
              </ul>

              <button class="learn_more-btn">Learn more &rarr;</button>
          </div>
          <div class="col-md-7 col-sm-12">
              <img src="assets/images/Payroll–1.png" alt="" class="payroll__img">
          </div>
      </div>
      <div class="case row">
          <div class="col-md-7 col-sm-12">
              <img src="assets/images/Payroll–1.png" alt="" class="payroll__img">
          </div>
          <div class="main__briefing col-md-5 col-sm-12">
              <h3 class="the_title">Payroll Management</h3>

              <p class="sub">Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio vero officia vel animi
                  incidunt consequuntur!</p>

              <ul>
                  <li>  Lorem ipsum dolor sit, amet consectetur adipisicing elit. At reiciendis sed quo, facilis
                      quas nulla deleniti!</li>  
                  <li>  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Delectus repellat ut cumque
                      perspiciatis mollitia, nihil sed?</li>  
                  <li>  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Delectus repellat ut cumque
                      perspiciatis mollitia, nihil sed?</li>  
              </ul>

              <button class="learn_more-btn">Learn more &rarr;</button>
          </div>
      </div>
  </section>
</main>


<footer class="footer">
  <h2 class="logo">EPIMS</h2>
  <div class="row">

      <div class="footer_content col-md-4 col-sm-12">
          <p class="footer_heading">Heading</p>
          <ul>
              <li>  Links</li>  
              <li>  Links</li>  
              <li>  Links</li>  
              <li>  Links</li>  
          </ul>
      </div>
      <div class="footer_content col-md-4 col-sm-12">
          <p class="footer_heading">Heading</p>
          <ul>
              <li>  Links</li>  
              <li>  Links</li>  
              <li>  Links</li>  
              <li>  Links</li>  
          </ul>
      </div>
      <div class="footer_content col-md-4 col-sm-12">
          <p class="footer_heading">Heading</p>
          <ul>
              <li>  Links</li>  
              <li>  Links</li>  
              <li>  Links</li>  
              <li>  Links</li>  
          </ul>
      </div>
  </div>

  <div class="icons"></div>

</footer> -->
